<template>
  <v-container fluid grid-list-md
  >
    <v-layout row wrap fill-height px-1>
      <v-flex xs12 md6>
        <v-card height="100%">
          <v-toolbar dense flat >
            <v-toolbar-title>Компания {{clientProps.nameShort}}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="profile">
              <v-layout row wrap>
              <v-text-field name="nameShort" :value="clientProps.nameShort" readonly label="Название" type="text"></v-text-field>
              <v-text-field name="inn" :value="clientProps.inn" readonly label="ИНН" type="text"></v-text-field>
              </v-layout>
              <v-layout row wrap>
              <v-text-field name="email" :value="clientProps.email" :readonly="!profileEdit" :rules="clientEmailRules" label="Эл. почта" type="text" :clearable="profileEdit"></v-text-field>
              <v-text-field name="phone" :value="clientProps.phone" :readonly="!profileEdit" :rules="phoneRules" label="Телефон" type="text" :clearable="profileEdit"></v-text-field>
              </v-layout>
              <v-textarea name="address" rows="3" :value="clientProps.address" :readonly="!profileEdit" label="Адрес" type="text" :clearable="profileEdit"></v-textarea>
               <v-subheader>Банковские реквизиты</v-subheader>
               <v-layout row wrap>
                <v-text-field name="bankDetails.account" :value="clientProps.bankDetails.account" :readonly="!profileEdit" :rules="accountRules" label="Р/с" type="text" :clearable="profileEdit"></v-text-field>
              </v-layout>
               <v-layout row wrap>
                <v-textarea name="bankDetails.bankName" rows="2" :value="clientProps.bankDetails.bankName" :readonly="!profileEdit" label="Название банка" type="text" :clearable="profileEdit"></v-textarea>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs8>
                  <v-text-field name="bankDetails.corrAccount" :value="clientProps.bankDetails.corrAccount" :readonly="!profileEdit" :rules="corrAccountRules"label="К/с" type="text" :clearable="profileEdit"></v-text-field>
                </v-flex>
                <v-flex xs4>
                <v-text-field name="bankDetails.bankBic" :value="clientProps.bankDetails.bankBic" :readonly="!profileEdit" label="БИК" type="text" :clearable="profileEdit" :rules="bankBicRules"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn :disabled="!getIsAllow({CLIENT_UPDATE: null})" v-show="!profileEdit" @click="profileEdit = !profileEdit">Изменить</v-btn>
            <v-btn v-show="profileEdit" @click="saveClientProfile">Сохранить</v-btn>
            <v-btn v-show="profileEdit" @click="cancel">Отменить</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-show="profileEdit" @click="updateFromEgrul">Обновить из ЕГРЮЛ</v-btn>
          </v-card-actions>
        </v-card>
        </v-flex>
      <v-flex xs12 md6>
        <v-card height="100%">
          <v-toolbar dense flat >
            <v-toolbar-title>Представители
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn :disabled="!getIsAllow({AGENT_CREATE: null})" icon @click="addUser()">
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list two-line>
            <template v-for="(item, index) in clientAccounts">
              <v-list-tile
                :key="item.title"
                @click="openUser(item.accountProfileId)"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.nameShort }}</v-list-tile-title>
                  <v-list-tile-sub-title class="text--primary"></v-list-tile-sub-title>
                  <v-list-tile-sub-title class="text--primary"></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-list-tile-action-text>{{ item.clientPhone }}</v-list-tile-action-text>
                  <v-list-tile-action-text></v-list-tile-action-text>
                  <v-list-tile-action-text>{{ item.clientEmail }}</v-list-tile-action-text>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider v-if="index + 1 < clientAccounts.length" :key="index"></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-flex>
        <v-flex xs12 md6>
        <v-card height="100%">
          <v-toolbar dense flat >
            <v-toolbar-title>Настройка
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-flex>
              <b>Мониторинг контрагентов в ЕГРЮЛ.</b>
              </v-flex>
              <v-flex>
              Отслеживание изменений информации о контрагентах полезно для минимизации рисков при заключении договоров.
              Для активации этой функциональности нажмите кнопку "Включить". После активации все "Мои контрагенты" будут поставлены на мониторинг и Вы будете получать рассылку об изменениях на почту компании.
              </v-flex>
            </v-card-text>
            <v-card-actions>
            <v-btn :disabled="!getIsAllow({MONITORING_SWITCH: null})" v-if="!getClientMonitoring" @click="switchMonitoring()">
              Включить
            </v-btn>
            <v-btn :disabled="!getIsAllow({MONITORING_SWITCH: null})" v-if="getClientMonitoring" @click="switchMonitoring()">
              Отключить
            </v-btn>
            </v-card-actions>
          </v-card>
          <v-card>
            <v-card-text >
              <v-flex>
              <b>Рассылка документов.</b>
              </v-flex>
             <div v-if="!clientProps.outgoing && !outgoingEdit"> 
              <v-flex>
              Позволяет в автоматическом режиме посылать документы после подготовки от имени клиента.
              Для использования функциональности нужно создать почтовый ящик на одном из почтовых сервисах и указать параметры SMTP сервера. Желательно в этом почтовом ящике настроить переадресацию почты на основоой адрес компании, чтобы не потерять отклики адресатов.
              </v-flex>
              <v-flex>
              Для активации функциональности нажмите кнопку "Включить".
              </v-flex>
            </div>
            <div v-if="clientProps.outgoing || outgoingEdit">
                        <v-flex xs12 md12>
            <v-card height="100%">
              <v-toolbar dense flat >
                <v-toolbar-title>Почтовые ящики
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn :disabled="!getIsAllow({MONITORING_SWITCH: null})" icon @click="openMailbox(null)">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-toolbar>
              <v-list two-line>
                <template v-for="(item, index) in clientMailboxes">
                  <v-list-tile
                    :key="item.title"
                    @click="openMailbox(item)"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title>{{ item.name || item.user }}</v-list-tile-title>
                      <v-list-tile-sub-title class="text--primary"></v-list-tile-sub-title>
                      <v-list-tile-sub-title class="text--primary"></v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-list-tile-action-text>{{ item.host }}</v-list-tile-action-text>
                      <v-list-tile-action-text></v-list-tile-action-text>
                      <v-list-tile-action-text>{{ item.user }}</v-list-tile-action-text>
                    </v-list-tile-action>
                  </v-list-tile>
                </template>
              </v-list>
            </v-card>
          </v-flex>

            </div>
            </v-card-text>
            <v-card-actions>
            <v-btn :disabled="!getIsAllow({MONITORING_SWITCH: null})" v-if="!clientProps.outgoing && !outgoingEdit" @click="outgoingEdit=true">
              Включить
            </v-btn>
            <v-btn v-show="outgoingEdit" @click="saveClientProfileOutgoing">Сохранить</v-btn>
            <v-btn v-show="outgoingEdit" @click="cancel">Отменить</v-btn>
            <v-btn :disabled="!getIsAllow({MONITORING_SWITCH: null})" v-if="!outgoingEdit && clientProps.outgoing" @click="turnOffOutgoing()">
              Отключить
            </v-btn>
            </v-card-actions>
          </v-card>
        </v-card>
      </v-flex>
            <v-flex xs12 md6>
        <v-card height="100%">
          <v-toolbar dense flat >
            <v-toolbar-title>Дополнительная информация
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text v-show="profileAddEdit">
            <v-form ref="profileAdd">
              <v-textarea name="about"
              auto-grow rows="1"
              :value="clientProps.about" label="О компании" type="text"  clearable></v-textarea>
              <v-text-field name="website" :value="clientProps.website" label="Интернет сайт" type="text"></v-text-field  clearable>
              <v-textarea name="contacts"
              auto-grow rows="1"
              :value="clientProps.contacts" label="Контакты" type="text"  clearable></v-textarea>
              <v-textarea name="services"
              auto-grow rows="1"
              :value="clientProps.services" label="Товары и услуги" type="text"  clearable></v-textarea>
              <v-textarea name="price"
              auto-grow rows="1"
              :value="clientProps.price" label="Цены" type="text"  clearable></v-textarea>
              <v-textarea
              prepend-icon="attach_file"
              @click:prepend="openDocSelector"
              auto-grow rows="1"
              name="docs" :value="clientProps.docs" label="Публичные документы" type="text"  clearable></v-textarea>
               <v-textarea name="tags"
              auto-grow rows="1"
              :value="clientProps.tags" label="Поисковые Теги" type="text"  clearable></v-textarea>
              <v-textarea name="other"
              auto-grow rows="1"
              :value="clientProps.other" label="Разное" type="text" clearable></v-textarea>
            </v-form>
          </v-card-text>
          <v-card-text v-show="!profileAddEdit">
            <v-client-preview :clientProfile="clientProps"></v-client-preview>
            <div ref="htmlDiv"></div>
          </v-card-text>
          <v-card-actions>
            <v-btn :disabled="!getIsAllow({CLIENT_UPDATE: null})" v-show="!profileAddEdit" @click="profileAddEdit = !profileAddEdit">Изменить</v-btn>
            <v-btn v-show="profileAddEdit" @click="saveClientProfileAdd">Сохранить</v-btn>
            <v-btn v-show="profileAddEdit" @click="cancel">Отменить</v-btn>
          </v-card-actions>

        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import vClientPreview from './ClientPreview'
  import vClientAgentForm from './ClientAgentForm'
  import depo from '../depo'
  import dialogs from '../common/dialogs'
  import client from '.'

  export default {
    components: {vClientPreview},
    data: () => ({
      profileEdit: false,
      profileAddEdit: false,
      outgoingEdit: false,
      selected: [],
      clientProps: null,
      rights: null,
      clientMailboxes: [],
      clientEmailRules: [
        v => !!v || 'Введите адрес Вашей корпоративной электронной почты, для оповещений системы',
        v => formats.isEmail(v) || 'Неверный формат эл. почты'
      ],
      phoneRules: [
        v => !!v || 'Введите телефон',
        v => formats.isPhone(formats.formatPhone(v)) || 'формат номера +7(921)3003333'
      ],
      accountRules: [
        v => !v || formats.isBankAccount(v) || 'неверный формат рассчетного счета'
      ],
      corrAccountRules: [
        v => !v || formats.isBankAccount(v) || 'неверный формат корресподентского счета'
      ],
      bankBicRules: [
        v => {
          const re = /^\d{9}$/
          return !v || re.test(String(v)) || 'неверный формат корресподентского счета'
        }
      ]
    }),
    created () {
      this.fetchAll()
      this.setClientProps()
    },
    mounted () {
      this.fetchAll()
    },
    watch: {
      getClientProfile: function (newVal, oldVal) { // watch it
        this.setClientProps()
      }
    },
    computed: {
      ...mapGetters({
        getClientProfile: 'getClientProfile',
        clientAccounts: 'getClientAccounts',
        getDepoUrl: 'getDepoUrl',
        getIsAllow: 'getIsAllow',
        getClientMonitoring: 'getClientMonitoring'
      })
    },
    methods: {
      fetchAll () {
        this.profileEdit = false
        this.profileAddEdit = false
        this.outgoingEdit = false
        this.$store.dispatch('fetchClientProfile')
        this.$store.dispatch('fetchClientAccounts')
        this.fetchMailboxes()
        this.fetchRights()
      },
      fetchMailboxes () {
        this.$store.dispatch('getClientMailboxes')
        .then(data => {
          this.clientMailboxes = data
          return
        })
      },
      cancel () {
        this.fetchAll()
      },
      setClientProps () {
        this.clientProps = Object.assign({}, this.getClientProfile)
        if (this.clientProps.outgoingConf) {
          this.clientProps.outgoingConf.bcc = this.clientProps.outgoingConf.bcc || this.clientProps.email
          this.clientProps.outgoingConf.replyTo = this.clientProps.outgoingConf.replyTo || this.clientProps.email
        }
      },
      updateFromEgrul () {
        this.profileEdit = false
        this.$store.dispatch('updateFromEgrul')
      },
      saveClientProfile () {
        if (this.$refs.profile.validate()) {
          var els = this.$refs.profile.$el.elements
          var d = Object.assign({}, this.clientProps)
          var bd = Object.assign({}, this.clientProps.bankDetails)
          d.email = els['email'].value
          d.address = els['address'].value
          d.phone = formats.formatPhone(els['phone'].value)
          d.inn = els['inn'].value
          bd.account = els['bankDetails.account'].value
          bd.bankName = els['bankDetails.bankName'].value
          bd.corrAccount = els['bankDetails.corrAccount'].value
          bd.bankBic = els['bankDetails.bankBic'].value
          d.bankDetails = bd
          this.$store.dispatch('saveClientProfile', d)
          this.profileEdit = false
        }
      },
      saveClientProfileOutgoing () {
        if (this.clientMailboxes.length > 0) {
          var d = Object.assign({}, this.clientProps)
          d.outgoing = true
          this.$store.dispatch('saveClientProfile', d).then(data => {
            this.outgoingEdit = false
            this.clientProps.outgoing = true
          })
        }
      },
      saveClientProfileAdd () {
        if (this.$refs.profileAdd.validate()) {
          var els = this.$refs.profileAdd.$el.elements
          var d = Object.assign({}, this.clientProps)
          d.website = els['website'].value
          d.about = els['about'].value
          d.contacts = els['contacts'].value
          d.services = els['services'].value
          d.price = els['price'].value
          d.docs = els['docs'].value
          d.tags = els['tags'].value
          d.other = els['other'].value
          this.$store.dispatch('saveClientProfile', d)
          this.profileAddEdit = false
        }
      },
      addLink: function (value) {
        this.$store.dispatch('getDepoFile', value).then(files => {
          var docLink = this.getDepoUrl(value)
          var docName = files && files[0] && files[0].docName || docLink
          var els = this.$refs.profileAdd.$el.elements
          this.clientProps.docs = els['docs'].value + `<p><a href="${docLink}">${docName}</a></p>`
        })
      },
      openDocSelector: function () {
        depo.selectDoc(this, this.addLink)
      },
      openUser (accountProfileId) {
        dialogs.register('v-client-agent-form', vClientAgentForm)
        var comp = { template: `
          <v-client-agent-form toolbar :itemId="itemId"
          v-on:close="$emit('close')"
            :fullscreen="$vuetify.breakpoint.xsOnly"></v-client-agent-form>
          `,
          data () {
            return {
              itemId: accountProfileId
            }
          }
        }
        this.dialogOpen(comp)
      },
      addUser () {
        this.openUser(null)
      },
      openMailbox (mailbox) {
        client.openClientMailbox(mailbox && mailbox.id || null)
        .then(() => { this.fetchMailboxes() })
      },
      dialogOpen (comp) {
        dialogs.modal(comp)
      },
      fetchRights () {
        this.$store.dispatch('fetchRights', {CLIENT_UPDATE: null, AGENT_CREATE: null, MONITORING_SWITCH: null})
      },
      switchMonitoring () {
        this.$store.dispatch('switchClientMonitoring', {monitoring: !this.getClientMonitoring, addFavorites: true})
      },
      turnOffOutgoing () {
        let d = Object.assign({}, this.clientProps)
        d.outgoing = false
        this.$store.dispatch('saveClientProfile', d)
      }

    }
  }
</script>



// WEBPACK FOOTER //
// ClientProfile.vue?93813dee